import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Stack,
  CircularProgress,
  Typography,
  Badge,
} from "@mui/material";
import {
  LocalFireDepartment,
  ChangeCircle,
  DownloadDone,
  Download,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const RecipeActions = ({
  isAdmin,
  recipeId,
  handleCook,
  handleDownload,
  isCooked,
  isDownloaded,
  isSubmitting,
  downloadError,
}) => {
  const navigate = useNavigate();
  return (
    <Stack spacing={2} sx={{ mb: 3 }}>
      <Button
        variant="contained"
        onClick={handleCook}
        startIcon={<LocalFireDepartment />}
        sx={{ borderRadius: 4, py: 1.5 }}
      >
        {isCooked ? "Cook Again" : "Select for Cooking"}
        {isCooked && (
          <Badge
            badgeContent="Previously Cooked"
            color="secondary"
            sx={{
              ml: 8,
              "& .MuiBadge-badge": {
                padding: "4px 8px",
                height: "auto",
              },
            }}
          />
        )}
      </Button>
      <Button
        variant="outlined"
        onClick={handleDownload}
        startIcon={isDownloaded ? <DownloadDone /> : <Download />}
        disabled={isSubmitting}
        sx={{ borderRadius: 4 }}
      >
        {isDownloaded ? "Download Again" : "Download Recipe"}
      </Button>

      {isSubmitting && (
        <Stack alignItems="center" spacing={1}>
          <CircularProgress size={24} />
          <Typography variant="body2">Downloading...</Typography>
        </Stack>
      )}

      {downloadError && (
        <Typography color="error" variant="body2">
          {downloadError}
        </Typography>
      )}

      {isAdmin && (
        <Stack spacing={2}>
          <Button
            variant="outlined"
            onClick={() => navigate(`/action-manager/${recipeId}`)}
            startIcon={<ChangeCircle />}
            sx={{ borderRadius: 4 }}
          >
            Manage Actions
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
RecipeActions.propTypes = {
  isAdmin: PropTypes.bool,
  recipeId: PropTypes.string,
  handleCook: PropTypes.func.isRequired,
  handleDownload: PropTypes.func,
  isCooked: PropTypes.bool,
  isDownloaded: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  downloadError: PropTypes.string,
};

export default RecipeActions;
